export default {
  SET_MUTE_INDICATION: (state, muteIndication) =>
    (state.muteIndication = muteIndication)
};
